import React from "react";
import { Box, Button, Text } from "@origin-digital/ods-core";
import { FilterButtonProps } from "./types";
import { SvgIcon } from "@origin-digital/ods-icons";

const Badge = ({
  count,
  "data-id": dataId = "filterButtonBadge",
}: FilterButtonProps["badge"]) => {
  if (count) {
    return (
      <Box
        display="inline-flex"
        justifyContent="center"
        alignItems="center"
        backgroundColor="critical"
        paddingX="xxsmall"
        zIndex={1}
        style={{
          height: "20px",
          minWidth: "20px",
          borderRadius: "48px",
        }}
        data-id={`${dataId}.root`}
      >
        <Text
          // @ts-expect-error: we need customise style
          style={{ fontSize: "11px" }}
          variant="caption"
          weight="medium"
          tone="white"
          align="center"
          data-id={`${dataId}.count`}
        >
          {count}
        </Text>
      </Box>
    );
  } else {
    return <></>;
  }
};

export const FilterButton = ({
  badge,
  "data-id": dataId = "filterButton",
  ...props
}: FilterButtonProps) => {
  return (
    <Button
      variant="text"
      color="secondaryB"
      size="small"
      noTextPadding
      {...(badge.count
        ? { startIcon: <Badge {...badge} data-id={`${dataId}.badge`} /> }
        : {
            icon: (
              <SvgIcon color="inherit" data-id={`${dataId}.icon`}>
                <path d="M19.2324 16.0713C20.9778 16.0715 22.3926 17.487 22.3926 19.2324C22.3924 20.9777 20.9777 22.3924 19.2324 22.3926C17.7455 22.3926 16.4992 21.3656 16.1621 19.9824H2.35742C1.94337 19.9824 1.60769 19.6464 1.60742 19.2324C1.60742 18.8182 1.94321 18.4824 2.35742 18.4824H16.1621C16.499 17.0989 17.7454 16.0713 19.2324 16.0713ZM19.2324 17.5713C18.3153 17.5713 17.5713 18.3153 17.5713 19.2324C17.5715 20.1494 18.3154 20.8926 19.2324 20.8926C20.1492 20.8924 20.8924 20.1492 20.8926 19.2324C20.8926 18.3154 20.1494 17.5715 19.2324 17.5713ZM12 8.83984C13.4868 8.84004 14.7324 9.86683 15.0693 11.25H21.6436C22.0576 11.2502 22.3936 11.5859 22.3936 12C22.3936 12.4141 22.0576 12.7498 21.6436 12.75H15.0693C14.7326 14.1333 13.4869 15.1609 12 15.1611C10.5129 15.1611 9.26656 14.1334 8.92969 12.75H2.35742C1.94321 12.75 1.60742 12.4142 1.60742 12C1.60742 11.5858 1.94321 11.25 2.35742 11.25H8.92969C9.26674 9.8667 10.5131 8.83984 12 8.83984ZM12 10.3398C11.0862 10.3398 10.3444 11.0778 10.3389 11.9902C10.3389 11.9935 10.3398 11.9967 10.3398 12C10.3398 12.0033 10.3389 12.0065 10.3389 12.0098C10.3441 12.9225 11.086 13.6611 12 13.6611C12.9167 13.6609 13.6597 12.9176 13.6602 12.001C13.6602 11.0839 12.917 10.3401 12 10.3398ZM4.76855 1.60742C6.25564 1.60761 7.50132 2.63492 7.83789 4.01855H21.6426C22.0568 4.01855 22.3926 4.35434 22.3926 4.76855C22.3923 5.18254 22.0566 5.51855 21.6426 5.51855H7.83789C7.50084 6.90139 6.25516 7.92852 4.76855 7.92871C3.02324 7.92871 1.60791 6.51376 1.60742 4.76855C1.60742 3.02294 3.02294 1.60742 4.76855 1.60742ZM4.76855 3.10742C3.85136 3.10742 3.10742 3.85136 3.10742 4.76855C3.10791 5.68533 3.85167 6.42871 4.76855 6.42871C5.68525 6.42848 6.42822 5.68519 6.42871 4.76855C6.42871 3.8515 5.68555 3.10765 4.76855 3.10742Z" />{" "}
              </SvgIcon>
            ),
          })}
      {...props}
      data-id={`${dataId}.root`}
    >
      Filters
    </Button>
  );
};
